




























import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import GlobalBus from '@/plugins/GlobalBus';
import NavbarHeader from './NavbarHeader.vue';
import TransitionExpand from '@/components/ui/TransitionExpand.vue';
import { GlobalBusNames } from '@/templates/DataNames';
import { State } from 'vuex-class';
import { currentInstance } from '@/heplers';

@Component({
  components: {
    NavbarHeader,
    TransitionExpand,
  },
})
export default class Header extends Vue {
  public isOpenMenu = false;
  public isShowMobile = false;
  public lastScroll = 0;
  @State('pageRendered') pageRendered: boolean;
  @State isMobile: boolean;
  $refs: {
    header: HTMLElement;
  };

  get computeHomeUrl() {
    return currentInstance === 'vox' ? '/docs' : '/kit/docs';
  }

  get isVox() {
    return currentInstance === 'vox';
  }

  get computeHeaderTitle() {
    return currentInstance === 'vox' ? 'voximplant' : 'voximplant Kit';
  }

  @Watch('$route')
  onRouteChange() {
    GlobalBus.emit(GlobalBusNames.CLOSEMOBILEMENU);
  }

  beforeDestroy() {
    GlobalBus.off(GlobalBusNames.ISMOBILE);
  }

  mounted() {
    GlobalBus.on(GlobalBusNames.ISMOBILE, (bool) => {
      this.isShowMobile = bool;
    });

    GlobalBus.on(GlobalBusNames.CLOSEMOBILEMENU, () => {
      this.isOpenMenu = false;
    });
  }
}
